import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToolsService } from 'tools';
import { FindHostResultDto } from 'UvExplorerServer.Dtos.TS/Tools';
import { MessageService } from 'base';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'netview';
import { IdentityService } from 'identity';
import { DiscResultsService } from '../../../discovery';
import { Subscription } from 'rxjs';


@Component({
	selector: 'find-host',
	templateUrl: './find-host.component.html',
	styleUrls: ['./find-host.component.scss']
})
export class FindHostComponent implements OnInit {

	public form: UntypedFormGroup;

	public dnsHostname: UntypedFormControl;
	public hostIpAddress: UntypedFormControl;
	public hostMacAddress: UntypedFormControl;
	public doLive: UntypedFormControl;

	public switchName: string;
	public ipAddress: string;
	public slotModule: string;
	public port: string;
	public vlan: string;

	public jackLabel: string;
	public jackRoom: string;
	public jackBuilding: string;


	constructor(private fb: UntypedFormBuilder, private toolsService: ToolsService,
		private messageService: MessageService, private navService: NavigationService,
		private identityService: IdentityService, private discResultsService: DiscResultsService,
		private changeDetector: ChangeDetectorRef) {

		let doLive = false;

		this.dnsHostname = new UntypedFormControl("", Validators.required);
		this.hostIpAddress = new UntypedFormControl("", Validators.required);
		this.hostMacAddress = new UntypedFormControl("", Validators.required);
		this.doLive = new UntypedFormControl(doLive);

		this.initResultFields();

		this.form = this.fb.group({
			dnsHostname: this.dnsHostname,
			hostIpAddress: this.hostIpAddress,
			doLive: this.doLive,
		});
	}

	private initResultFields(): void {
		this.switchName = "";
		this.ipAddress = "";
		this.slotModule = "";
		this.port = "";
		this.vlan = "";
		this.jackRoom = "";
		this.jackLabel = "";
		this.jackBuilding = "";
	}

	ngOnInit(): void {
	}

	private initData(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
	}

	public get enableLookup(): boolean {
		return ((!!this.dnsHostname.value) || (!!this.hostIpAddress.value) || (!!this.hostMacAddress.value))
	}

	public lookup(): void {

		this.initResultFields();

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		this.toolsService.findHost(sessionGuid, netViewGuid, agentGuid, schedDiscGuid, schedDiscRsltGuid,
			this.dnsHostname.value, this.hostIpAddress.value, this.hostMacAddress.value, this.doLive.value).subscribe(
				(result: FindHostResultDto) => {
					this.switchName = result.switchName;
					this.ipAddress = result.ipAddress;
					this.slotModule = result.slotModule;
					this.port = result.port;
					this.vlan = result.vlan;
					this.jackBuilding = result.jackBuilding;
					this.jackRoom = result.jackRoom;
					this.jackLabel = result.jackLabel;

					if (!this.hostIpAddress.value && result.hostIpAddress) {
						var tmpIP = result.hostIpAddress;
						this.hostIpAddress.setValue(result.hostIpAddress);
					}
					if (!this.hostMacAddress.value && result.hostMacAddress) {
						var tmpMAC = result.hostMacAddress;
						this.hostMacAddress.setValue(tmpMAC);
					}
					if (!this.dnsHostname.value && result.dnsHostname) {
						var tmpHOST = result.dnsHostname;
						this.dnsHostname.setValue(result.dnsHostname);
					}

					if (!this.switchName) {
						this.messageService.displayErrorMessage("Host was not found");
					}

					//this.changeDetector.markForCheck();
					this.changeDetector.detectChanges();
				},
				(error) => {
					this.messageService.displayErrorMessage("Host was not found");
				});
	}

	public resetFields(): void {
		if (this.dnsHostname)
			this.dnsHostname.setValue('');
		if (this.hostIpAddress)
			this.hostIpAddress.setValue('');
		if (this.hostMacAddress)
			this.hostMacAddress.setValue('');

		this.initResultFields();
	}

}
